import React from 'react';
import PropTypes from 'prop-types';
import { Field as ReduxFormField } from 'redux-form';
import ValidatedField from '../ValidatedField/ValidatedField';

export const propTypes = {
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

function Field(props) {
    return <ReduxFormField {...props} component={renderField} inputComponent={props.component} />;
}

Field.propTypes = propTypes;

export function renderField(props) {
    const {
        children,
        className,
        errorStyle,
        help,
        id = props.input.name,
        input,
        inputComponent: InputComponent,
        label,
        meta,
        notificationType,
        showErrorNotification,
        ...rest
    } = props;
    const { componentType } = InputComponent;

    return (
        <ValidatedField
            className={className}
            error={meta.touched && meta.error ? meta.error : null}
            errorStyle={componentType === 'select' || componentType === 'customSelect' ? 'highlight' : errorStyle}
            help={help}
            htmlFor={id}
            label={label}
            notificationType={notificationType}
            showErrorNotification={showErrorNotification}
        >
            <InputComponent {...input} {...rest} id={id}>
                {children}
            </InputComponent>
        </ValidatedField>
    );
}

renderField.propTypes = {
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
    }).isRequired,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }).isRequired,
    id: PropTypes.string,
    label: PropTypes.string,
    help: PropTypes.string,
    inputComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    errorStyle: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    showErrorNotification: PropTypes.bool,
    notificationType: PropTypes.bool,
};
renderField.defaultProps = {
    inputComponent: 'input',
    showErrorNotification: true,
};

export default Field;
